export default __webpack_public_path__ + "static/metals-project-1f7cb267d58076f1b48c2969f3087208.png";